import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

/**
 * Сервис навигации по карточке товара
 * Регистрирует компоненты с директивой sdProductCardNavigation в блоке навигации.
 *
 * Массив visibleTabs вынесен в отдельное свойство, по следующей причине:
 * Директива sdProductCardNavigation добавляется к каждому компоненту, который
 * находится внутри родительского компонента с табами. Во время инициализации,
 * директива вызывает метод addToVisibleTabs. Вызов происходит асинхронно, при
 * монтировании каждого компонента. А это значит что могут возникнуть коллизии.
 * Соответственно необходимо чтобы при одновременном обращении к свойству visibleTabs,
 * изменения производились на основе актуальных данных.
 */
@Injectable({
  providedIn: 'root',
})
export class ProductCardNavigationService {
  private visibleTabs = new Set();

  private visibleTabs$ = new BehaviorSubject([]);
  private activeTab$ = new BehaviorSubject(null);

  constructor(private location: Location) {}

  getActiveTab(): Observable<string | null> {
    return this.activeTab$.asObservable();
  }

  setActiveTab(uid: string | null): void {
    this.activeTab$.next(uid);
    const hash = uid ? `#${uid}` : '';
    this.location.replaceState(`${this.location.path(false)}${hash}`);
  }

  getVisibleTabs(): Observable<string[]> {
    // задержка между отправкой событий добавлена для исправления бага в задаче HYB2-2031
    return this.visibleTabs$.pipe(delay(0));
  }

  addToVisibleTabs(uid: string): void {
    this.visibleTabs.add(uid);
    this.emitVisibleTabs();
  }

  removeFromVisibleTabs(uid: string): void {
    if (this.activeTab$.getValue() === uid) {
      this.setActiveTab(null);
    }

    this.visibleTabs.delete(uid);
    this.emitVisibleTabs();
  }

  private emitVisibleTabs(): void {
    this.visibleTabs$.next([...this.visibleTabs] as string[]);
  }
}
